import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'semantic-ui-react';
import { useNavigate, useParams } from 'react-router-dom';
import { API, showError, showSuccess } from '../../helpers';

const EditModelGroup = () => {
  const params = useParams();
  const groupId = params.id;
  const isEdit = groupId !== undefined;
  const [loading, setLoading] = useState(isEdit);
  const [modelOptions, setModelOptions] = useState([]);
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({
    name: '',
    models: [],
    description: '',
    status: 1,
  });

  const handleInputChange = (e, { name, value }) => {
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const loadModelGroup = async () => {
    try {
      const res = await API.get(`/api/model_group/${groupId}`);
      const { success, message, data } = res.data;
      if (success && data) {
        setInputs({
          name: data.name || '',
          models: data.models ? data.models.split(',').filter((m) => m.trim()) : [],
          description: data.description || '',
          status: data.status || 1,
        });
      } else {
        showError(message);
      }
    } catch (error) {
      showError(error.message);
    }
    setLoading(false);
  };

  const loadAllModels = async () => {
    try {
      const res = await API.get('/api/channel/models');
      const { data } = res.data;
      if (data) {
        const modelSet = new Set();
        data.forEach((m) => {
          if (m.id) modelSet.add(m.id);
        });
        const options = Array.from(modelSet)
          .sort()
          .map((m) => ({ key: m, text: m, value: m }));
        setModelOptions(options);
      }
    } catch (error) {
      showError(error.message);
    }
  };

  useEffect(() => {
    loadAllModels().then();
    if (isEdit) {
      loadModelGroup().then();
    }
  }, []);

  const submit = async () => {
    if (inputs.name === '') {
      showError('名称不能为空');
      return;
    }
    const payload = {
      name: inputs.name,
      models: inputs.models.join(','),
      description: inputs.description,
      status: inputs.status,
    };

    let res;
    if (isEdit) {
      res = await API.put('/api/model_group/', {
        ...payload,
        id: parseInt(groupId),
      });
    } else {
      res = await API.post('/api/model_group/', payload);
    }

    const { success, message } = res.data;
    if (success) {
      showSuccess(isEdit ? '更新成功' : '创建成功');
      if (!isEdit) {
        navigate('/model-group');
      }
    } else {
      showError(message);
    }
  };

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header>
            {isEdit ? '编辑模型组' : '创建模型组'}
          </Card.Header>
          <Form loading={loading} style={{ marginTop: '20px' }}>
            <Form.Field>
              <Form.Input
                label='名称'
                name='name'
                placeholder='模型组名称，如 premium-models'
                onChange={handleInputChange}
                value={inputs.name}
                required
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                label='描述'
                name='description'
                placeholder='模型组描述'
                onChange={handleInputChange}
                value={inputs.description}
              />
            </Form.Field>
            <Form.Field>
              <Form.Dropdown
                label='模型列表'
                placeholder='选择模型'
                name='models'
                fluid
                multiple
                search
                selection
                allowAdditions
                additionLabel='添加自定义模型: '
                onChange={handleInputChange}
                value={inputs.models}
                options={[
                  ...modelOptions,
                  ...inputs.models
                    .filter((m) => !modelOptions.find((o) => o.value === m))
                    .map((m) => ({ key: m, text: m, value: m })),
                ]}
              />
            </Form.Field>
            <Button positive onClick={submit}>
              提交
            </Button>
            <Button onClick={() => navigate('/model-group')}>取消</Button>
          </Form>
        </Card.Content>
      </Card>
    </div>
  );
};

export default EditModelGroup;
